import { testimonials, siteInfo } from "@/mocks/archive";

export default function TestimonialSection() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 md:mb-10">
        <div>
          <span className="text-xs tracking-[0.22em] text-primary-600">READER NOTES</span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            读者怎么用这份档案
          </h2>
        </div>
        <p className="max-w-md text-sm text-foreground-600 leading-relaxed">
          {siteInfo.brand} 从 2019 年做到现在，感谢每一位愿意先看时间轴再下结论的读者。
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {testimonials.map((item) => (
          <figure
            key={item.name}
            className="flex flex-col p-6 rounded-lg bg-background-100 border border-background-300"
          >
            <i className="ri-double-quotes-l text-2xl text-primary-300 mb-3"></i>
            <blockquote className="text-sm text-foreground-700 leading-relaxed flex-1">
              {item.text}
            </blockquote>
            <figcaption className="mt-5 pt-4 border-t border-background-300 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-900 text-sm font-medium">
                {item.name.slice(0, 1)}
              </span>
              <span className="flex flex-col">
                <span className="text-sm font-medium text-foreground-950">{item.name}</span>
                <span className="text-[11px] text-foreground-500">{item.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}